import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const BoxStyled = styled(Box)({
  display: 'flex',
});

export const ProfileBoxStyled = styled(Box)({
  display: 'flex',
  gap: '8px',
});
